import React, { useEffect, useState } from "react";
import { subscribeCompanyRelationshipsChanged } from "../utils/companyRelationshipCounts";
import { readApiJson } from "../utils/apiResponse";

let cachedRows = [];
let loadedAt = 0;
let pending;

async function loadCounts() {
  if (Date.now() - loadedAt < 60000) return cachedRows;
  if (!pending) {
    const token = ["token", "authToken", "jwt", "accessToken", "access_token"]
      .map((key) => localStorage.getItem(key) || sessionStorage.getItem(key)).find(Boolean);
    const base = String(process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");
    pending = fetch(`${base}/api/companies/job-counts`, {
      credentials: "include", headers: token ? { Authorization: `Bearer ${token}` } : {},
    }).then((response) => readApiJson(response, "Company job counts"))
      .then((payload) => {
        if (!Array.isArray(payload.rows)) throw new Error("Invalid company counts response");
        cachedRows = payload.rows;
        loadedAt = Date.now();
        return cachedRows;
      }).finally(() => { pending = null; });
  }
  return pending;
}

export function companyLabelWithJobCount(company, rows = []) {
  const name = typeof company === "string" ? company : company?.company_name || company?.name || company?.label || "";
  const id = typeof company === "object" ? company?.company_id ?? company?.id : null;
  const matches = rows.filter((row) => id != null
    ? String(row.id) === String(id)
    : String(row.name).trim().toLowerCase() === String(name).trim().toLowerCase());
  const raw = matches.length ? matches.reduce((sum, row) => sum + Number(row.jobs_count || 0), 0)
    : company?.jobs_count ?? company?.jobsCount;
  const count = raw == null || raw === "" ? null : Number(raw);
  return count != null && Number.isFinite(count) && count >= 0 ? `${name} (${count})` : name;
}

export default function CompanyOptionLabel({ company }) {
  const [rows, setRows] = useState(cachedRows);
  useEffect(() => {
    let active = true;
    const refresh = () => {
      loadCounts().then((next) => { if (active) setRows(next); }).catch(() => {});
    };
    refresh();
    const unsubscribe = subscribeCompanyRelationshipsChanged(() => { loadedAt = 0; refresh(); });
    return () => { active = false; unsubscribe(); };
  }, []);
  return <>{companyLabelWithJobCount(company, rows)}</>;
}
